<script setup lang="ts">
import EventList from '@/components/features/events/EventList.vue'
import type { Context } from '@/utils/types'
import { onMounted, provide, ref } from 'vue'
import EventCalendar from '@/components/features/events/EventCalendar.vue'
import { CalendarIcon, TableCellsIcon } from '@heroicons/vue/24/outline'
import EventCreate from '@/components/features/events/EventCreate.vue'
import CommercialFilter from '@/components/filters/CommercialFilter.vue'
import { useEventStore } from '@/stores/useEventStore'
import { useUserStore } from '@/stores/useUserStore'
import { storeToRefs } from 'pinia'
import { UserRole } from '@/utils/enums'
import { useRoute } from 'vue-router'
import Bs2Title from '@/components/common/layout/Bs2Title.vue'

  const $route = useRoute()
// Récupération des paramètres de requête depuis l'URL
const queryType = ($route.query.type || 'kanban') as string
const context: Context = 'user'

const diaryView = ref(true)
const eventStore = useEventStore()
const userStore = useUserStore()
const { userConnected, role } = storeToRefs(userStore)
const { filters } = storeToRefs(eventStore)

onMounted(async () => {
  diaryView.value = queryType !== 'list'
})

provide('context', context)
</script>

<template>
  <div class="flex flex-col w-full">
    <div class="grid gap-4 p-8 pb-0">
      <div class="flex flex-col gap-12">
        <Bs2Title title="Agenda" />
      </div>
      <div class="flex gap-3 items-end justify-between">
        <EventCreate />
        <CommercialFilter
          v-if="role === UserRole.Manager && userConnected"
          v-model="filters.selectedCommercials"
        />
        <div class="flex justify-end mb-3">
          <label class="swap swap-flip">
            <input type="checkbox" v-model="diaryView" />
            <div class="swap-on tooltip tooltip-left" data-tip="Liste">
              <component :is="TableCellsIcon" class="w-6 h-6" />
            </div>
            <div class="swap-off tooltip tooltip-left" data-tip="Agenda">
              <component :is="CalendarIcon" class="w-6 h-6" />
            </div>
          </label>
        </div>
      </div>
    </div>
    <div class="p-8" v-if="diaryView">
      <EventCalendar :show-add-button="false" :show-filter-commercial="false" />
    </div>
    <div class="p-8" v-else>
      <EventList :show-add-button="false" />
    </div>
  </div>
</template>
